routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.footerCore', {
      url: "footerCore",
      template: `<footer-core sh-ctrl="shCtrl"></footer-core>`
    });
}

export default routesConfig;



// WEBPACK FOOTER //
// ./www/components/footer-core/footer-core.config.js